// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"637":"7b3bd7c5","1414":"b9cf6075","6084":"1cab5024","6325":"8b42a120","9061":"faf77cb6"}[chunkId] + ".chunk.css";
};